import React, { Component } from 'react';
import { hot } from 'react-hot-loader';

import { BrowserRouter, Route, Switch } from 'react-router-dom';

import classNames from 'classnames/bind';
import Header from './components/Header';

import IndexPage from './pages/IndexPage';
import OverviewPage from './pages/OverviewPage';
import DigitalPage from './pages/DigitalPage';
import InvestPage from './pages/InvestPage';
import InterviewPage from './pages/InterviewPage';
import ScrollToTop from './components/ScrollToTop';

import style from './App.scss';

const ctx = classNames.bind(style);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <BrowserRouter
        basename={process.env.NODE_ENV === 'production' ? 'alfa-private' : '/'}
      >
        <div className={ctx('app')}>
          <Header />
          <Switch>
            <Route exact path="/" component={IndexPage} />
            <Route path="/overview" component={OverviewPage} />
            <Route path="/digital" component={DigitalPage} />
            <Route path="/invest" component={InvestPage} />
            <Route path="/invest/" component={InvestPage} />
            <Route path="/interview" component={InterviewPage} />
            <Route path="/main" component={IndexPage} />
          </Switch>
          <ScrollToTop />
        </div>
      </BrowserRouter>
    );
  }
}

export default hot(module)(App);

// https://tylermcginnis.com/react-router-cannot-get-url-refresh/
